import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Destination } from 'src/app/models/destination.model';
import { ExpenseResponse } from 'src/app/models/expense.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { DestinationService } from 'src/app/services/destination.service';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';

@Component({
  selector: 'app-modal-assigning-detination-expense',
  templateUrl: './modal-assigning-detination-expense.component.html',
  styleUrls: ['./modal-assigning-detination-expense.component.scss']
})
export class ModalAssigningDetinationExpenseComponent implements OnInit {
  @Input() currentExpense: ExpenseResponse;
  @Output() closed = new EventEmitter<any>();
  @Output() close = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  destinations: Destination[] = [];
  filterDestination: Destination[] = [];

  inputs = {
    destination: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  }
  loadingCreate = false;

  constructor(
    private destinationService: DestinationService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.getDestinations();
  }

  getDestinations() {
    this.destinationService.getDestinationsActive(true).subscribe({
      next: (response: ResponseObject) => {
        this.destinations = response.data;
        this.filterDestination = this.destinations;
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener las bodegas", "Error");
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeDestination(input) {
    const inputValue = input.target.value;

    this.filterDestination = this.destinations.filter((w) =>
      w.name.toLowerCase().includes(inputValue.toLowerCase())
    );

    if (this.filterDestination.length == 0) {
      this.changeInput(this.inputs.destination, null, false, null, 'fa-xmark', null);
    } else if (this.filterDestination.length == 1) {
      this.changeInput(this.inputs.destination, this.filterDestination[0].name, true, null, 'fa-circle-check', this.filterDestination[0]);
    } else {
      this.changeInput(this.inputs.destination, input.target.value, false, null, 'fa-list', null);
    }
  }

  checkDestination(destination: Destination) {
    this.inputs.destination.class = "fa-circle-check";
    this.inputs.destination.verified = true;
    this.inputs.destination.data = destination;
    this.inputs.destination.value = destination.name;
  }

  createAssociation(modal: ModalDialogComponent) {
    if (!this.verifyForm)
      return;
    if (this.currentExpense == null) {
      this.toastrService.error("Error no se tiene gasto para asignar", "Error");
      return;
    }

    this.loadingCreate = true;
    this.destinationService.createDestinationExpense(this.inputs.destination.data.id, this.currentExpense.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastrService.success("Se asocion el gasto al destino correctamente", "Exito");
        this.loadingCreate = false;
        this.closeModal(modal);
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al crear la asociacion del destino al gasto", "Error");
        this.loadingCreate = false;
      }
    });
  }

  get verifyForm() {
    if (this.inputs.destination.verified) {
      return true;
    }
    return false;
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(true);
  }

  closeModalEmit() {
    this.closed.emit(true);
  }
}
